<ngb-carousel
  *ngIf="temamembers && temamembers.length > 0"
  [showNavigationArrows]="true"
  [showNavigationIndicators]="groupedMembers.length > 1"
  [interval]="0"
  class="team-carousel">

  <ng-template ngbSlide *ngFor="let group of groupedMembers">
    <div class="row justify-content-center">
      <div class="col-lg-3 col-md-6 mt-4 pt-2 animate-team" *ngFor="let item of group; let i = index"
           [style.animation-delay]="(i * 0.1) + 's'">

        <div class="card team team-primary text-center border-0 team-card">
          <div class="position-relative">
            <img [src]="item.ImageUrl"
                 class="img-fluid avatar avatar-ex-large rounded-circle shadow" alt="">
            <ul class="list-unstyled mb-0 team-icon">
              <li class="list-inline-item ms-1">
                <a [href]="item.Facebook" class="btn btn-primary btn-pills btn-sm btn-icon">
                  <i-feather name="facebook" class="icons"></i-feather>
                </a>
              </li>
              <li class="list-inline-item ms-1">
                <a [href]="item.Instagram" class="btn btn-primary btn-pills btn-sm btn-icon">
                  <i-feather name="instagram" class="icons"></i-feather>
                </a>
              </li>
              <li class="list-inline-item ms-1">
                <a [href]="item.Twitter" class="btn btn-primary btn-pills btn-sm btn-icon">
                  <i-feather name="twitter" class="icons"></i-feather>
                </a>
              </li>
              <li class="list-inline-item ms-1">
                <a [href]="item.LinkedIn" class="btn btn-primary btn-pills btn-sm btn-icon">
                  <i-feather name="linkedin" class="icons"></i-feather>
                </a>
              </li>
            </ul>
            <!--end icon-->
          </div>
          <div class="card-body py-3 px-0 content">
            <h5 class="mb-0">
              <a href="javascript:void(0)" class="name text-dark">
                {{ currentLang != 'ar' ? item.NameEn : item.NameAr }}
              </a>
            </h5>
            <small class="designation text-muted">
              {{ currentLang != 'ar' ? item.JobTitleEn : item.JobTitleAr }}
            </small>
          </div>
        </div>

      </div>
      <!--end col-->
    </div>
    <!--end row-->
  </ng-template>

</ngb-carousel>